import { Component } from '@angular/core';

@Component({
  selector: 'app-sso-diagram',
  templateUrl: './sso-diagram.component.html',
  styleUrls: ['./sso-diagram.component.scss'],
})
export class SsoDiagramComponent {}
